import { inject, Injectable } from '@angular/core'
import { User } from './users.service'
import { injectQuery } from '@ngneat/query'
import { HttpClient } from '@angular/common/http'
import { queryKeys } from './query-keys'

export type Configuration = { tinyMceApiKey: string }

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  query = injectQuery()
  httpClient = inject(HttpClient)

  getConfiguration() {
    return this.query({
      queryKey: queryKeys.configuration,
      queryFn: () => this.httpClient.get<Configuration>(`/api/config`),
    }).result$
  }
}
